module.exports = __webpack_public_path__ + "static/media/pickQuestion.432bbb60.svg";